import { render, staticRenderFns } from "./orderWxshenpiUsa.vue?vue&type=template&id=67bf9676&scoped=true"
import script from "./orderWxshenpiUsa.vue?vue&type=script&lang=js"
export * from "./orderWxshenpiUsa.vue?vue&type=script&lang=js"
import style0 from "./orderWxshenpiUsa.vue?vue&type=style&index=0&id=67bf9676&prod&scoped=true&lang=css"
import style1 from "./orderWxshenpiUsa.vue?vue&type=style&index=1&id=67bf9676&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bf9676",
  null
  
)

export default component.exports